module.exports = __webpack_public_path__ + "static/media/Bookmark.9de680b9.svg";